import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import MainBlock from '../MainBlock';
import PaymentBlock from '../PaymentBlock';
import WarehouseBlock from '../WarehouseBlock';
import PackingsBlock from '../PackingsBlock';
import ReturnsBlock from '../ReturnsBlock';
import ClientBlock from '../ClientBlock';
import DeliveryBlock from '../DeliveryBlock';
import CommentBlock from '../CommentBlock';
import MoreBlock from '../MoreBlock';
import MobileHeeader from '../Header/MobileHeader';
import MobileHistoryBlock from '../HistoryBlock/MobileHistoryBlock';
import WorksheetBlock from '../WorksheetBlock';
import ShippingOptionsBlock from '../ShippingOptionsBlock';
import DocsBlock from '../DocsBlock';
import AdAttachmentsBlock from '../AdAttachmentsBlock';

const Wrapper = styled('div')`
  margin: 0 -22px;

  .help-tooltip {
    right: -10px;
    left: auto;
  }

  .card-box {
    min-height: 200px;
    border-radius: 0;
    border-left: none;
    border-right: none;
    margin-bottom: 20px;
    padding: 16px 0;

    &.disabled,
    &.add-info {
      display: flex;
      flex-direction: column;
    }

    &.card-box-main {
      position: static;
      padding-bottom: 0;
    }

    .card-title {
      margin: 0;
      padding: 0 16px 9px;

      .header-title {
        font-size: 14px;
      }
    }

    .payment-flex {
      padding: 0 16px;

      .payment-flex-block {
        padding-top: 16px;
      }

      .border-top {
        margin-left: -16px;
        margin-right: -16px;
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    .border-top {
      padding-left: 16px;
      padding-right: 16px;
    }

    .card-content {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
  .block-subtitle {
    color: #98a6ad;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .change-link {
    color: #7e57c2;
    cursor: pointer;
  }
  .border-top {
    border-top: 1px solid #ccc;
    padding-top: 15px;
  }
  .blocked-block {
    border-top: 1px solid #ccc;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ccc;
  }

  div.tags-wrapper {
    padding: 0 16px;

    .tag {
      padding: 0 16px;
    }
  }

  .status-badge,
  .payment-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-left: 10px;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background: #ccc;
    border: 1px solid #fff;
    color: #296775;
    padding: 2px 8px 0;
    min-width: 80px;
    text-align: center;
    height: 19px;

    i {
      font-size: 12px;
      margin-top: -2px;
    }
    .payment-badge-main > div {
      text-align: left;
    }
  }

  .packing {
    .packings-wrapper {
      padding: 0;
      position: relative;
    }

    .packing-main {
      position: relative;
    }

    .packing-top {
      flex-direction: column;
      align-items: flex-start;
      .pallet-barcode {
        margin-left: 0 !important;
      }
    }

    .pallet-item {
      flex-direction: column;
      .parameters {
        margin-top: 5px;
      }
    }

    .parameters {
      margin: 10px 0 0 !important;

      span {
        display: block;
        margin: 0 !important;
      }
    }

    .show-packing-info-button {
      position: absolute;
      top: 20px;
      right: 10px;
      left: unset;
      bottom: unset;
      color: #72747b;
      font-size: 12px;
      font-weight: 600;
    }
  }
`;

const MobileLayout = (props) => {
  const {
    history,
    isNew,
    currentOrder,
    PaymentBadge,
    haveProducts,
    loadingOrder,
    currentWarehouse,
    sum,
    isManualWarehouse,
    stickerUrl,
    loadingSticker,
    worksheetData,
    handleEditOrderItems,
    handleConfirmation,
    handleRefreshReserve,
    handleCancel,
    handleUpdateDeliveryResult,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    handleCopyOrder,
    actualizeOrder,
    loadingPayment,
    handleEditPayment,
    warehouses,
    handleEditOrder,
    orderHistory,
    loadingClient,
    handleEditClient,
    loadingComment,
    handleEditComment,
    setMobileCustomMenu,
    handleAddTag,
    handleEditDelivery,
    handleEditDiscounts,
    handlePhoneCallBack,
    isFbm,
    fbmType,
    showFbmDocsUnnecessary,
    isCopy,
    setIsCopy,
  } = props;

  useEffect(() => {
    setMobileCustomMenu(null);
  }, [setMobileCustomMenu]);

  return (
    <>
      <MobileHeeader
        history={history}
        isNew={isNew}
        currentOrder={currentOrder}
        PaymentBadge={PaymentBadge}
      />
      <Wrapper>
        <MainBlock
          isNew={isNew}
          haveProducts={haveProducts}
          currentOrder={currentOrder}
          loadingOrder={loadingOrder}
          currentWarehouse={currentWarehouse}
          sum={sum}
          isManualWarehouse={isManualWarehouse}
          stickerUrl={stickerUrl}
          loadingSticker={loadingSticker}
          worksheetData={worksheetData}
          handleEditOrderItems={handleEditOrderItems}
          handleConfirmation={handleConfirmation}
          handleRefreshReserve={handleRefreshReserve}
          handleCancel={handleCancel}
          handleUpdateDeliveryResult={handleUpdateDeliveryResult}
          handlePacking={handlePacking}
          handleSendPackingControl={handleSendPackingControl}
          handleDownloadSticker={handleDownloadSticker}
          handleCopyOrder={handleCopyOrder}
          actualizeOrder={actualizeOrder}
          handleAddTag={handleAddTag}
          handleEditDiscounts={handleEditDiscounts}
          handlePhoneCallBack={handlePhoneCallBack}
          handleEditOrder={handleEditOrder}
        />
        <PaymentBlock
          haveProducts={haveProducts}
          currentOrder={currentOrder}
          sum={sum}
          loadingPayment={loadingPayment}
          PaymentBadge={PaymentBadge}
          handleEditPayment={handleEditPayment}
        />
        <WarehouseBlock
          warehouses={warehouses}
          currentWarehouse={currentWarehouse}
          currentOrder={currentOrder}
          handleEditOrder={handleEditOrder}
        />

        {currentOrder.packings && currentOrder.packings.length ? (
          <PackingsBlock
            currentOrder={currentOrder}
            requirements={worksheetData?.requirements}
            actualizeOrder={actualizeOrder}
          />
        ) : null}

        {currentOrder?.returns?.length ? (
          <div className="row">
            <div className="col-12">
              <ReturnsBlock currentOrder={currentOrder} />
            </div>
          </div>
        ) : null}

        <ClientBlock
          isNew={isNew}
          currentOrder={currentOrder}
          loadingClient={loadingClient}
          handleEditClient={handleEditClient}
          handleEditOrder={handleEditOrder}
        />

        {worksheetData?.requirements?.form ? (
          <WorksheetBlock
            isNew={isNew}
            currentOrder={currentOrder}
            fields={worksheetData.form_content}
          />
        ) : null}

        {isFbm && !isNew && fbmType !== 'FBO_B2B' ? (
          <ShippingOptionsBlock currentOrder={currentOrder} handleEditOrder={handleEditOrder} />
        ) : null}

        <DeliveryBlock
          sum={sum}
          haveProducts={haveProducts}
          currentOrder={currentOrder}
          handleEditDelivery={handleEditDelivery}
        />

        <DocsBlock
          currentOrder={currentOrder}
          actualizeOrder={actualizeOrder}
          handleEditOrder={handleEditOrder}
          isNew={isNew}
          showFbmDocsUnnecessary={showFbmDocsUnnecessary}
        />

        <AdAttachmentsBlock
          currentOrder={currentOrder}
          haveProducts={haveProducts}
          handleEditOrder={handleEditOrder}
        />

        <CommentBlock
          currentOrder={currentOrder}
          haveProducts={haveProducts}
          loadingComment={loadingComment}
          handleEditComment={handleEditComment}
        />

        <MoreBlock
          currentOrder={currentOrder}
          handleEditOrder={handleEditOrder}
          fbmType={fbmType}
          actualizeOrder={actualizeOrder}
          setIsCopy={setIsCopy}
          isCopy={isCopy}
        />

        {orderHistory.length ? <MobileHistoryBlock orderHistory={orderHistory} /> : null}
      </Wrapper>
    </>
  );
};

export default MobileLayout;
